import { useParams } from 'react-router-dom';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { flowEditorState } from '@duke-hq/app-admin-web/components/ReactFlow/flowEditorState';
import { useEffect } from 'react';

export function useResourceByQueryId() {
  const { resourceId } = useParams<{ resourceId: string }>();

  if (!resourceId) {
    throw new Error('resourceId is required');
  }

  const resourceQuery = trpcAdmin.resources.byId.useQuery(resourceId);

  useEffect(() => {
    if (resourceQuery.data) {
      flowEditorState.resource = resourceQuery.data;
    }

    return () => {
      flowEditorState.resource = null;
    };
  }, [resourceQuery.data]);

  return {
    data: resourceQuery.data,
    isLoading: resourceQuery.isLoading,
    refetch: resourceQuery.refetch,
  };
}
